import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonLink } from 'components/shared/ButtonLink';
import { Heading2, Heading3 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import {
  StyledSection,
  StyledTip,
  StyledTipImage,
  StyledTips
} from './HPCTips.styled';

type TipsProps = {
  tips?: any[];
};

const HPCTips: React.FC<TipsProps> = ({ tips }) => {
  const { t } = useI18n('hiring-process-comparison');

  return (
    <StyledSection id="tips">
      <Heading2 editorial>{t('hiring-process-comparison.tips.title')}</Heading2>
      <StyledTips>
        {tips
          ?.sort((a, b) => a.attributes.order - b.attributes.order)
          .map(({ id, attributes }) => (
            <StyledTip key={id}>
              <div>
                <Heading3 editorial>{attributes.title}</Heading3>
                <p>{attributes.description}</p>
                <ButtonLink href={attributes.link} target="_blank">
                  <FontAwesomeIcon icon={faCheckCircle} />
                  <span>{attributes.buttonText}</span>
                </ButtonLink>
              </div>
              <StyledTipImage>
                <img
                  src={attributes.image.data.attributes.url}
                  alt={attributes.image.data.attributes.alternativeText}
                />
              </StyledTipImage>
            </StyledTip>
          ))}
      </StyledTips>
    </StyledSection>
  );
};

export default HPCTips;
